<template>

    <div class="view__image__modal" id="modal" :class="(this.image_preview) ? 'visible' : ''">
        <div class="wrapper">
            <div class="content">
                <div class="preview" :style="{ backgroundImage: get_image_url(), backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }"></div>

                <img class="close__modal" src="/images/icons/x.png" @click="closeModal"/>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        data(){
            return {
                image_preview: null
            }
        },
        created(){},
        methods: {
            showModal(image){
                this.image_preview = image;
                document.body.style = 'overflow: hidden';
                document.getElementById('modal').addEventListener('click', this.closeModal);
            },

            get_image_url(){
                return  "url('" + this.image_preview + "')";
            },

            closeModal(e){
                if(e.target.classList.contains('view__image__modal') || e.target.classList.contains('close__modal')){
                    this.image_preview = null;
                    document.body.style = 'overflow: initial';
                    document.getElementById('modal').removeEventListener('click', this.closeModal);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .view__image__modal{
        background: rgba(0,0,0,.7);
        height: 100%;
        left: 0;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 100000000;
        display: none;

        &.visible{
            display: block;
        }

        .wrapper{
            background: #212121;
            border-radius: 8px;
            height: auto;
            max-height: 80vh;
            max-width: 90vw;
            position: absolute;
            right: 50%;
            top: 50%;
            transform: translate(50%, -50%);
            width: auto;
            border: 1px solid #ED1163;

            .content{
                padding: 42px;
                position: relative;

                .preview{
                    // width: auto;
                    // height: 50vh;
                    // width: 100%;
                    // height: auto;
                    width: 50vw;
                    min-height: 50vh;
                    display: block;
                    margin: auto;
                }

                .close__modal{
                    cursor: pointer;
                    display: block;
                    position: absolute;
                    top: 15px;
                    right: 15px;
                    width: 14px;
                    height: 14px;
                    transition: all .3s ease;

                    &:hover{
                        transform: scale(1.3);
                    }

                }
            }
        }
    }

    @media screen and (max-width: 836px) {

        .view__image__modal{
            .wrapper{
                width: 90vw;

                .content{
                    padding: 12px;

                    .preview{
                        // height: 100%;
                        min-height: 25vh;
                        width: 100%;
                    }

                    .close__modal{
                        top: 110%;
                        right: 50%;
                    }
                }
            }
        }

    }

</style>